import Page from "../Page";
import Box from "../Box";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AvailableSessions from "../AvailableSessions";
import ScheduledSessions from "../ScheduledSessions";
import {
  getSchedule,
  getRegistration,
  getAvailablePresenationsByDay,
  removePendingPresentation,
  resolveScheduleConflict,
  savePendingPresentation,
  removeFullPresentations,
} from "../../api/registration";

import { saveNoPaymentRegistration } from "../../api/checkout";
import { getConferenceFees } from "../../api/conferenceFee";
import { idleTimeoutMinutes, storageKeys } from "../../config";
import IdleTimer from "react-idle-timer";
import { groupBy } from "../../api/util";
import * as accountActions from "../../actions/accountActions";
import * as registrationActions from "../../actions/registrationActions";

import Moment from "react-moment";
import Modal from "../Modal";
import Select from "react-select";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import LoadingButton from "../LoadingButton";
import LoadingContent from "../LoadingContent";
import { toast } from "react-toastify";

const strings = {
  conflictMessage:
    "Resolve existing conflicts in your schedule before checking out",
};

class SessionsPage extends PureComponent {
  static propTypes = {
    joinRenewMembershipType: PropTypes.string,
    registrationMembershipType: PropTypes.string,
    history: PropTypes.object.isRequired,
    getMe: PropTypes.func.isRequired,
    clearRegistrationMethod: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this._idleTimer = null;
    this.state = {
      registration: {
        days: [],
        daysOfTheWeek: [],
        therapeuticAreas: [],
        speakers: [],
      },
      availablePresentations: [],
      filteredPresentations: {},
      showAllSessions: true,
      currentDay: 0,
      filterText: "",
      filter: {
        therapeuticAreas: [],
        speakers: [],
      },
      filterType: "topic",
      showFilter: false,
      selectedSpeakerOptions: [],
      schedule: {
        days: [],
        registeredPresentations: [],
        waitlistApprovedPresentations: [],
      },
      showIdleModal: false,
      showFeeDetailsModal: false,
      loading: true,
      conferenceFees: {
        totalWorkshopFees: 0,
        eventFee: 0,
        totalDue: 0,
        staffCredits: [],
        eventDiscount: {},
      },
      isLoading: false,
      isLoadingSessions: false,
      showResolveConflictModal: false,
      showRemovedPresentationsModal: false,
      conflictingPresentations: [],
      selectedPresentationId: null,
      removedPresentations: [],
      isCheckoutDisabled: false,
      eventType: this.props.me.event,
    };
  }

  componentDidMount = () => {
    this.props.clearRegistrationMethod();

    this._getConferenceFees();
    this._getRegistration();
    this._getAvailablePresenationsByDay(this.state.currentDay);
    this._getSchedule();
  };

  _getRegistration = () => {
    getRegistration().then((response) => {
      this.setState({
        registration: response,
      });
    });
  };

  _getSchedule = (sessionAdded, sessionId) => {
    getSchedule()
      .then((response) => {
        if (
          response.registeredPresentations.length === 0 &&
          this.state.event.conferenceType === "National" &&
          this.state.currentDay === 0 &&
          this.state.showAllSessions
        ) {
          toast(
            "Tuesday is primarily a workshop day with added fees. Several non-fee sessions are held later in the afternoon."
          );
        }

        this.setState({
          schedule: response,
        });

        if (sessionAdded) {
          const presentation = this.state.schedule.registeredPresentations.find(
            (p) => p.id === sessionId
          );
          let hasLinkedSessionConflict = false;
          presentation.presentationGroups
            .map((pg) => pg.linkedPresentationId)
            .forEach((linkedPresentationId) => {
              if (this._hasScheduleConflicts(linkedPresentationId)) {
                hasLinkedSessionConflict = true;
                return false;
              }
            });

          if (
            this._hasScheduleConflicts(sessionId) ||
            hasLinkedSessionConflict
          ) {
            toast.warning("The added session has caused a scheduling conflict");
          }
        }
      })
      .catch((error) => {});
  };

  _getConferenceFees = () => {
    this.setState({
      isCheckoutDisabled: true,
    });

    getConferenceFees(
      this.props.registrationMembershipType,
      this.props.joinRenewMembershipType,
      localStorage.getItem(storageKeys.promoCode)
    ).then((response) => {
      this.setState({
        conferenceFees: response,
        loading: false,
        isCheckoutDisabled: false,
      });
    });
  };

  _getAvailablePresenationsByDay = (index) => {
    getAvailablePresenationsByDay(index).then((response) => {
      this.setState({
        isLoadingSessions: false,
      });
      this._applyFilter(response);
    });
  };

  _resolveConflict = (presentationId) => {
    resolveScheduleConflict(presentationId).then((response) => {
      toast.success("Conflicts have been resolved");
      this._getAvailablePresenationsByDay(this.state.currentDay);
      this._getSchedule();
      this._getConferenceFees();
    });
  };

  _applyFilter = (presentations) => {
    var filteredPresentations = [];
    let { filter } = this.state;
    let { filterType } = this.state;

    if (filterType === "topic") {
      if (filter.therapeuticAreas.length > 0) {
        filter.therapeuticAreas.forEach((t) => {
          presentations.forEach((p) => {
            if (p.therapeuticAreas.map((ta) => ta.id).indexOf(t) !== -1) {
              if (!filteredPresentations.find((fp) => fp.id === p.id)) {
                filteredPresentations.push(p);
              }
            }
          });
        });
      } else {
        filteredPresentations = presentations;
      }
    } else if (filterType === "speaker") {
      if (filter.speakers.length > 0) {
        filter.speakers.forEach((s) => {
          presentations.forEach((p) => {
            if (p.speakers.map((ta) => ta.id).indexOf(s) !== -1) {
              if (!filteredPresentations.find((fp) => fp.id === p.id)) {
                filteredPresentations.push(p);
              }
            }
          });
        });
      } else {
        filteredPresentations = presentations;
      }
    }

    let grouped = groupBy(filteredPresentations, "startTime");
    this.setState({
      availablePresentations: presentations,
      filteredPresentations: grouped,
    });
  };

  _changeDay = (index) => {
    if (index !== this.state.currentDay) {
      this.setState({
        currentDay: index,
        showAllSessions: true,
        isLoadingSessions: true,
      });

      this._getAvailablePresenationsByDay(index);
    } else if (!this.state.showAllSessions) {
      this.setState({
        showAllSessions: true,
      });
    }

    window.scrollTo(0, 0);
  };

  _toggleFilter = () => {
    this.setState({ showFilter: !this.state.showFilter });
  };

  _clearFilters = (e) => {
    let { filter } = this.state;
    filter.therapeuticAreas = [];
    filter.speakers = [];

    this.setState({
      filterText: "",
      filter,
      selectedSpeakerOptions: [],
      selectedTherapeuticAreaOptions: [],
    });

    this._applyFilter(this.state.availablePresentations);
  };

  _updateSpeakerFilter = (selectedSpeakerOptions) => {
    let { filter } = this.state;
    filter.speakers = [];
    selectedSpeakerOptions.forEach((option) => {
      filter.speakers.push(option.value);
    });

    this.setState({ filter, selectedSpeakerOptions });

    let { registration } = this.state;
    var selectedItems = [];

    registration.speakers.forEach((element) => {
      const index = filter.speakers.indexOf(element.id);
      if (index !== -1) {
        selectedItems.push(element.firstName + " " + element.lastName);
      }
    });

    this.setState({ filterText: selectedItems.join(", ") });

    this._applyFilter(this.state.availablePresentations);
  };

  _updateTherapeuticAreaFilter = (selectedTherapeuticAreaOptions) => {
    let { filter } = this.state;
    filter.therapeuticAreas = [];
    selectedTherapeuticAreaOptions.forEach((option) => {
      filter.therapeuticAreas.push(option.value);
    });

    this.setState({ filter, selectedTherapeuticAreaOptions });

    let { registration } = this.state;
    var selectedItems = [];

    registration.therapeuticAreas.forEach((element) => {
      const index = filter.therapeuticAreas.indexOf(element.id);
      if (index !== -1) {
        selectedItems.push(element.name);
      }
    });

    this.setState({ filterText: selectedItems.join(", ") });

    this._applyFilter(this.state.availablePresentations);
  };

  _addSession = (id, e, confirmedWaitlist) => {
    let { availablePresentations } = this.state;
    savePendingPresentation(id)
      .then(() => {
        let presentation = availablePresentations.find(
          (p) => p.id === parseInt(id)
        );

        if (!presentation) {
          presentation = this.state.schedule.registeredPresentations.find(
            (p) => p.id === parseInt(id)
          );
        }

        toast.success("Added " + presentation.titleShortName);

        if (presentation) {
          if (!presentation.isFull) {
            presentation.isNotify = false;
          }

          if (presentation.isFull && !presentation.hasWaitlist) {
            presentation.isNotify = true;
          } else {
            if (presentation.isFull && presentation.hasWaitlist) {
              presentation.isWaitlist = true;
            }

            presentation.isRegistered = true;
          }

          if (confirmedWaitlist) {
            presentation.isWaitlist = false;
          }

          let linkedSessions = availablePresentations.filter((p) =>
            presentation.presentationGroups
              .map((pg) => pg.linkedPresentationId)
              .includes(p.id)
          );
          linkedSessions.forEach((ls) => {
            ls.isRegistered = true;
            toast.success("Added " + ls.titleShortName);
          });
        }

        this._applyFilter(this.state.availablePresentations);
      })
      .then(() => {
        this._getSchedule(true, id);
        this._getConferenceFees();
      });

    e.stopPropagation();
  };

  _removeSession = (id, e) => {
    let { availablePresentations } = this.state;
    removePendingPresentation(id)
      .then(() => {
        let presentation = availablePresentations.find(
          (p) => p.id === parseInt(id)
        );
        if (presentation) {
          toast.success("Removed " + presentation.titleShortName);
          presentation.isRegistered = false;
          presentation.isNotify = false;
          presentation.isWaitlist = false;

          let linkedSessions = availablePresentations.filter((p) =>
            presentation.presentationGroups
              .map((pg) => pg.linkedPresentationId)
              .includes(p.id)
          );
          linkedSessions.forEach((ls) => {
            ls.isRegistered = false;
            toast.success("Removed " + ls.titleShortName);
          });
        }

        this._applyFilter(this.state.availablePresentations);
      })
      .then(() => {
        this._getSchedule();
        this._getConferenceFees();
      });

    e.stopPropagation();
  };

  _checkout = () => {
    this.setState({
      isLoading: true,
    });

    removeFullPresentations().then((removedPresentations) => {
      if (removedPresentations.length > 0) {
        this.setState({
          showRemovedPresentationsModal: true,
          removedPresentations,
          isLoading: false,
        });
      } else {
        this._goToCheckout();
      }
    });
  };

  _goToCheckout = () => {
    if (this.state.conferenceFees.total > 0) {
      this.props.history.push("/checkout");
    } else {
      saveNoPaymentRegistration().then((response) => {
        if (response.success) {
          localStorage.clear();
          window.location.href = "/registration-complete?paymentProcessed=true";
        }
      });
    }
  };

  _hideRemovedPresentationsModal = (checkout) => {
    Promise.all([
      getSchedule(),
      getConferenceFees(
        this.props.registrationMembershipType,
        this.props.joinRenewMembershipType,
        localStorage.getItem(storageKeys.promoCode)
      ),
    ]).then((responses) => {
      this.setState({
        schedule: responses[0],
        conferenceFees: responses[1],
        showRemovedPresentationsModal: false,
        removedPresentations: [],
      });

      if (checkout) {
        this._checkout();
      }
    });
  };

  _removedPresentationsModal = () => {
    const { removedPresentations } = this.state;

    return (
      <Modal
        show={this.state.showRemovedPresentationsModal}
        onClose={() => this._hideRemovedPresentationsModal(false)}
      >
        <h2 className="conflict">Sessions Full</h2>
        <p>
          Since the time you selected them, the following sessions have filled
          up and have been removed from your registration. You can go back and
          register for the waitlist, or continue with payment (you will not be
          charged for any removed sessions that have fees).
        </p>
        {removedPresentations.map((presentation, index) => (
          <div key={index} className="conflicting-sessions-container">
            <div className="row conflicting-session">
              <div className="col-12 pb-4 presentation-info">
                <div className="presentation-title">
                  <label htmlFor={presentation.id}>
                    {presentation.titleShortName}
                  </label>
                </div>
                <div className="details">
                  <label htmlFor={presentation.id}>
                    <Moment format="dddd">
                      {presentation.presentationDate}
                    </Moment>
                    , <Moment format="h:mm A">{presentation.startTime}</Moment>{" "}
                    - <Moment format="h:mm A">{presentation.endTime}</Moment>
                    {presentation.presentationFee > 0 && (
                      <span>
                        <span> : </span>
                        <span className="fee">
                          ${presentation.presentationFee.toFixed(2)} Fee
                        </span>
                      </span>
                    )}
                  </label>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="row mt-4">
          <div className="col-6 pr-1">
            <button
              className="btn btn-primary btn-block"
              onClick={() => this._hideRemovedPresentationsModal(false)}
            >
              Select Sessions
            </button>
          </div>
          <div className="col-6 pl-1">
            <button
              className="btn btn-primary btn-block"
              onClick={() => this._hideRemovedPresentationsModal(true)}
            >
              Continue
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  _updateFilterType = (e) => {
    this.setState({ filterType: e.target.value });
    this._clearFilters();
  };

  _onIdle = (e) => {
    this.setState({ showIdleModal: true });
  };

  _closeIdleModal = () => {
    this.props.history.go(0);
  };

  _idleModal = () => {
    return (
      <Modal show={this.state.showIdleModal} onClose={this._closeIdleModal}>
        <h2 className="linked">Inactive Session</h2>
        <p>
          We're sorry, your session has timed out due to
          inactivity.&nbsp;&nbsp;Please click continue to restart your session.
        </p>
        <button
          className="btn btn-primary btn-block"
          onClick={(e) => this._closeIdleModal()}
        >
          Continue
        </button>
      </Modal>
    );
  };

  _showFeeDetailsModal = () => {
    this.setState({
      showFeeDetailsModal: true,
    });
  };

  _hideFeeDetailsModal = () => {
    this.setState({
      showFeeDetailsModal: false,
    });
  };

  _feeDetailsModal = () => {
    let { conferenceFees } = this.state;

    return (
      <Modal
        show={this.state.showFeeDetailsModal}
        onClose={this._hideFeeDetailsModal}
      >
        <div className="fee-details">
          <h2 className="linked mb-2">Fee Details</h2>
          {conferenceFees.total >= 0 ? (
            <div className="row text-bold mb-2">
              <div className="col-8">Total Due: </div>
              <div className="col-4">${conferenceFees.total.toFixed(2)}</div>
            </div>
          ) : (
            <div className="row text-bold mb-2">
              <div className="col-4">Credit Due: </div>
              <div className="col-4">${conferenceFees.total.toFixed(2)}</div>
            </div>
          )}
          {conferenceFees.amountPaid > 0 && (
            <div className="row mb-2">
              <div className="col-8">Total Paid:</div>
              <div className="col-4">
                ${conferenceFees.amountPaid.toFixed(2)}
              </div>
            </div>
          )}
          <div className="option-text mb-1">Fee Summary:</div>
          {conferenceFees.membershipFee && (
            <div className="row">
              <div className="col-8">
                {conferenceFees.membershipFee.membershipType} Fee:
              </div>
              <div className="col-4">
                ${conferenceFees.membershipFee.price.toFixed(2)}
              </div>
            </div>
          )}
          {conferenceFees.eventFee > 0 && (
            <div className="row">
              <div className="col-8">{conferenceFees.eventFeeDescription}:</div>
              <div className="col-4">${conferenceFees.eventFee.toFixed(2)}</div>
            </div>
          )}
          {conferenceFees.totalWorkshopFees > 0 && (
            <div className="row">
              <div className="col-8">Workshop Fee(s):</div>
              <div className="col-4">
                ${conferenceFees.totalWorkshopFees.toFixed(2)}
              </div>
            </div>
          )}
          {conferenceFees.spgFee !== null && (
            <div className="row">
              <div className="col-8">SPG Fee:</div>
              <div className="col-4">
                ${conferenceFees.spgFee.amount.toFixed(2)}
              </div>
            </div>
          )}
          {((conferenceFees.staffCredits &&
            conferenceFees.staffCredits.length > 0) ||
            conferenceFees.eventDiscount ||
            conferenceFees.promoCode) && (
            <div className="option-text mb-1 mt-2">Discounts & Waivers:</div>
          )}
          {conferenceFees.promoCode && (
            <div className="row pb-1 discounts">
              <div className="col-8">Promotional Code:</div>
              <div className="col-4">{conferenceFees.promoCode}</div>
            </div>
          )}
          {conferenceFees.staffCredits.map((item) => (
            <div className="row discounts">
              <div className="col-8">{item.reason}:</div>
              <div className="col-4 red-text">{item.amount.toFixed(2)}</div>
            </div>
          ))}
          {conferenceFees.eventDiscountTotal > 0 && (
            <div className="row discounts">
              <div className="col-8">Event Discount:</div>
              <div className="col-4 red-text">
                -${conferenceFees.eventDiscountTotal.toFixed(2)}
              </div>
            </div>
          )}
          {!this._hasScheduleConflicts() && (
            <LoadingButton
              className="mt-4"
              onClick={(e) => this._checkout()}
              disabled={
                this._hasScheduleConflicts() || this.state.isCheckoutDisabled
              }
              text={this._actionButtonText()}
              loadingText="Saving ..."
              isLoading={this.state.isLoading}
            />
          )}

          {this._hasScheduleConflicts() && (
            <button
              className="mt-4 btn btn-block btn-red"
              onClick={(e) => this._resolveScheduleConflict()}
            >
              Resolve {this._getConflictingPresentationCount()} Conflicts
            </button>
          )}
        </div>
      </Modal>
    );
  };

  _showResolveConflictModal = (presentationId, e) => {
    if (e) {
      e.stopPropagation();
    }

    const conflictingPresentations = this.state.schedule.registeredPresentations.filter(
      (p) =>
        p.id === presentationId ||
        p.conflictingPresentationIds.includes(presentationId)
    );

    this.setState({ showResolveConflictModal: true, conflictingPresentations });
  };

  _hideResolveConflictModal = () => {
    this.setState({ showResolveConflictModal: false });
  };

  _getConflictingPresentations = (presentationId) => {
    return this.state.schedule.registeredPresentations.filter(
      (p) =>
        p.id === presentationId ||
        p.conflictingPresentationIds.includes(presentationId)
    );
  };

  _getConflictingPresentationCount = () => {
    const presentation = this.state.schedule.registeredPresentations.find(
      (item) => {
        return item.conflictingPresentationIds.length > 0;
      }
    );

    const conflictingPresentations = this._getConflictingPresentations(
      presentation.id
    );
    return conflictingPresentations.length;
  };

  _resolveScheduleConflict = () => {
    const presentation = this.state.schedule.registeredPresentations.find(
      (item) => {
        return item.conflictingPresentationIds.length > 0;
      }
    );

    if (presentation) {
      const conflictingPresentations = this._getConflictingPresentations(
        presentation.id
      );
      this.setState({
        conflictingPresentations,
        showResolveConflictModal: true,
      });
    }
  };

  _changeSelectedPresentation = (e) => {
    this.setState({ selectedPresentationId: parseInt(e.target.value) });
  };

  _saveSelectedPresentation = () => {
    this._resolveConflict(this.state.selectedPresentationId);
    this.setState({ selectedPresentationId: null });
    this._hideResolveConflictModal();
  };

  _resolveConflictModal = () => {
    const { conflictingPresentations } = this.state;

    return (
      <Modal
        show={this.state.showResolveConflictModal}
        onClose={this._hideResolveConflictModal}
      >
        <h2 className="conflict">Resolve Schedule Conflict</h2>
        <p>
          You have selected two or more sessions with the same start time, a
          repeat session or a different level of this workshop. Choose one
          session below.
        </p>
        {conflictingPresentations.map((presentation, index) => (
          <div key={index} className="conflicting-sessions-container">
            <div className="row conflicting-session">
              <div className="col-1">
                <input
                  type="radio"
                  value={presentation.id}
                  checked={
                    this.state.selectedPresentationId === presentation.id
                  }
                  onChange={this._changeSelectedPresentation}
                  id={presentation.id}
                />
              </div>
              <div className="col-11 pb-4 presentation-info">
                <div className="presentation-title">
                  <label htmlFor={presentation.id}>
                    {presentation.titleShortName}
                  </label>
                </div>
                <div className="details">
                  <label htmlFor={presentation.id}>
                    <Moment format="dddd">
                      {presentation.presentationDate}
                    </Moment>
                    , <Moment format="h:mm A">{presentation.startTime}</Moment>{" "}
                    - <Moment format="h:mm A">{presentation.endTime}</Moment>
                    {presentation.presentationFee > 0 && (
                      <span>
                        <span> : </span>
                        <span className="fee">
                          ${presentation.presentationFee.toFixed(2)} Fee
                        </span>
                      </span>
                    )}
                  </label>
                </div>
              </div>
            </div>
          </div>
        ))}
        <button
          className="btn btn-primary btn-block"
          disabled={!this.state.selectedPresentationId}
          onClick={this._saveSelectedPresentation}
        >
          Resolve Conflict
        </button>
      </Modal>
    );
  };

  _actionButtonText = () => {
    if (
      this.state.conferenceFees.total > 0 ||
      (this.state.schedule.registeredPresentations.length === 0 &&
        !this.props.me.isRegistered)
    ) {
      return "Checkout";
    } else {
      return "Finalize Schedule";
    }
  };

  _hasGroupConflict = (sessionId) => {
    const { registeredPresentations } = this.state.schedule;
    const presentation = registeredPresentations.find(
      (p) => p.id === sessionId
    );
    const levels = groupBy(
      registeredPresentations.filter((rp) => rp.level !== null),
      "groupName"
    );
    const groups = registeredPresentations
      .filter((rp) => rp.groupName !== null)
      .map((rp) => rp.groupName);

    if (
      presentation.id !== sessionId &&
      levels &&
      levels.length > 0 &&
      levels[presentation.groupName] !== presentation.level
    ) {
      return true;
    } else if (
      presentation.id !== sessionId &&
      groups.filter((g) => g === presentation.groupName).length > 0
    ) {
      return true;
    }

    return false;
  };

  _hasScheduleConflicts = (addedSessionId) => {
    const { registeredPresentations } = this.state.schedule;

    if (addedSessionId) {
      const presentation = registeredPresentations.find(
        (p) => p.id === addedSessionId
      );
      if (presentation) {
        if (presentation.conflictingPresentationIds.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    let hasConflict = false;

    registeredPresentations.forEach((item) => {
      if (item.conflictingPresentationIds.length > 0) {
        hasConflict = true;
        return false;
      } else if (this._hasGroupConflict(item.id)) {
        hasConflict = true;
        return false;
      }
    });

    return hasConflict;
  };

  _waitlistApprovedPresentations = () => {
    const { waitlistApprovedPresentations } = this.state.schedule;
    if (waitlistApprovedPresentations.length > 0) {
      return (
        <div className="waitlist-approved-container p-4 mt-2 mb-4">
          <div className="header mb-4">
            You Have Been Approved To Attend The Following Session(s).
          </div>
          {waitlistApprovedPresentations.map((approvedPresentation, index) => (
            <div className="row ml-3 mr-3" key={index}>
              {this._waitlistApprovedItems(approvedPresentation)}
            </div>
          ))}
        </div>
      );
    }
  };

  _waitlistApprovedItems = (approvedPresentation) => {
    let registeredPresentations = this.state.schedule.registeredPresentations;
    const conflictingPresentations = registeredPresentations.filter((p) =>
      approvedPresentation.conflictingPresentationIds.includes(p.id)
    );

    return (
      <React.Fragment>
        <div className="col-lg">
          <div className="text-bold mb-2">Approved Session:</div>
          <div>{approvedPresentation.presentationTitle}</div>
          <div className="session-time mt-1 mb-3">
            <Moment format="dddd">
              {approvedPresentation.presentationDate}
            </Moment>
            , <Moment format="h:mm A">{approvedPresentation.startTime}</Moment>{" "}
            - <Moment format="h:mm A">{approvedPresentation.endTime}</Moment>
          </div>
          {conflictingPresentations.length > 0 && (
            <button
              className="btn btn-blue mt-4 w-65"
              onClick={(e) =>
                this._addSession(approvedPresentation.id, e, true)
              }
            >
              Accept Approved Session
            </button>
          )}
          {conflictingPresentations.length === 0 && (
            <div className="row">
              <div className="col-lg-6">
                <button
                  className="btn btn-blue mt-lg-4 mt-2 w-65"
                  onClick={(e) =>
                    this._addSession(approvedPresentation.id, e, true)
                  }
                >
                  Accept Approved Session
                </button>
              </div>
              <div className="col-lg-6">
                <button
                  className="btn btn-blue mt-lg-4 mt-2 w-65 ml-lg-5"
                  onClick={(e) =>
                    this._removeSession(approvedPresentation.id, e)
                  }
                >
                  Decline Session
                </button>
              </div>
            </div>
          )}
        </div>
        {conflictingPresentations.length > 0 && (
          <div className="col-lg">
            <div className="conflicting-sessions pl-lg-5 pb-1">
              <div className="text-bold mb-2">
                Current Session: (Will Be Replaced):
              </div>
              {conflictingPresentations.map((presentation, index) => (
                <div className="conflicting-session" key={index}>
                  <div>{presentation.presentationTitle}</div>
                  <div className="session-time mt-lg-1 mb-lg-3">
                    <Moment format="dddd">
                      {presentation.presentationDate}
                    </Moment>
                    , <Moment format="h:mm A">{presentation.startTime}</Moment>{" "}
                    - <Moment format="h:mm A">{presentation.endTime}</Moment>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="btn btn-blue mt-lg-4 mt-2 w-65 ml-lg-5"
              onClick={(e) => this._removeSession(approvedPresentation.id, e)}
            >
              Keep Current Session
            </button>
          </div>
        )}
      </React.Fragment>
    );
  };

  _setShowAllSessions = (showAllSessions) => {
    this.setState({ showAllSessions });
    window.scrollTo(0, 0);
  };

  render() {
    if (this.state.loading) {
      return <LoadingContent />;
    }

    let { registration } = this.state;
    let { filteredPresentations } = this.state;
    let { conferenceFees } = this.state;

    let speakerOptions = [];
    registration.speakers.forEach((item) => {
      speakerOptions.push({
        label: item.firstName + " " + item.lastName,
        value: item.id,
      });
    });

    let therapeuticAreaOptions = [];
    registration.therapeuticAreas.forEach((item) => {
      therapeuticAreaOptions.push({ label: item.name, value: item.id });
      therapeuticAreaOptions.push();
    });

    return (
      <Page title="Conference Registration">
        <Box title="Session Selection">
          <IdleTimer
            element={document}
            onIdle={this._onIdle}
            stopOnIdle={true}
            timeout={1000 * 60 * idleTimeoutMinutes}
          />

          <div className="session-selection-header d-none d-lg-block">
            <div className="row">
              <div className="col-md-4">
                <div className="row">
                  <div className="col-md-12">
                    <div className="option-text mb-2">View:</div>
                  </div>
                </div>
                <div className="row pt-2 pb-2">
                  <div className="col-md-5 pr-0">
                    <button
                      className={
                        "btn btn-primary btn-option btn-block " +
                        (this.state.showAllSessions ? "active" : "")
                      }
                      onClick={(e) => this._setShowAllSessions(true)}
                    >
                      All Sessions
                    </button>
                  </div>
                  <div className="col-md-7">
                    <button
                      className={
                        "btn btn-primary btn-option btn-block " +
                        (!this.state.showAllSessions ? "active" : "")
                      }
                      onClick={(e) => this._setShowAllSessions(false)}
                    >
                      Tentative Schedule
                    </button>
                  </div>
                </div>
              </div>
              {this.state.showAllSessions ? (
                <React.Fragment>
                  <div className="col-md-6">
                    <div className="row ml-1">
                      <div className="col-md-12">
                        <div className="option-text mb-2">Conference Day:</div>
                      </div>
                    </div>
                    <div className="row ml-1 pr-3 pl-2 mr-1 pt-2 pb-2 days">
                      {registration.days.map((day, index) => (
                        <button
                          key={index}
                          className={
                            "btn btn-primary btn-option btn-day col ml-2 " +
                            (this.state.currentDay === index ? "active" : "")
                          }
                          onClick={(e) => this._changeDay(index)}
                        >
                          <Moment format="ddd">{day}</Moment>
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="option-text mb-2">Filter:</div>
                      </div>
                    </div>
                    <div className="row pt-2 pb-2">
                      <div className="col-md-12">
                        <div
                          className={
                            "btn-filter " +
                            (this.state.showFilter ? "active" : "")
                          }
                          onClick={this._toggleFilter}
                        >
                          <div
                            className={
                              "arrow " + (this.state.showFilter ? "up" : "down")
                            }
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-3">
                    <div className="row ml-1">
                      <div className="col-md-12">
                        <div className="option-text mb-2">Fee Summary:</div>
                      </div>
                    </div>
                    {conferenceFees.amountPaid > 0 && (
                      <div className="row pl-3 fees pb-1">
                        <div className="col-md-9 pr-0">Total Paid:</div>
                        <div className="col-md-3 pl-2">
                          ${conferenceFees.amountPaid.toFixed(2)}
                        </div>
                      </div>
                    )}
                    {conferenceFees.membershipFee && (
                      <div className="row pl-3 fees pb-1">
                        <div className="col-md-9 pr-0">
                          {conferenceFees.membershipFee.memberTypeName} Fee:
                        </div>
                        <div className="col-md-3 pl-2">
                          ${conferenceFees.membershipFee.price.toFixed(2)}
                        </div>
                      </div>
                    )}
                    {conferenceFees.eventFee > 0 && (
                      <div className="row pl-3 fees pb-1">
                        <div className="col-md-9 pr-0">
                          {conferenceFees.eventFeeDescription}:
                        </div>
                        <div className="col-md-3 pl-2">
                          ${conferenceFees.eventFee.toFixed(2)}
                        </div>
                      </div>
                    )}
                    {conferenceFees.totalWorkshopFees > 0 && (
                      <div className="row pl-3 fees pb-1">
                        <div className="col-md-9 pr-0">Workshop Fee(s):</div>
                        <div className="col-md-3 pl-2">
                          ${conferenceFees.totalWorkshopFees.toFixed(2)}
                        </div>
                      </div>
                    )}
                    {conferenceFees.spgFee !== null && (
                      <div className="row pl-3 fees pb-1">
                        <div className="col-md-9 pr-0">SPG Fee:</div>
                        <div className="col-md-3 pl-2">
                          ${conferenceFees.spgFee.amount.toFixed(2)}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-md-3">
                    {((conferenceFees.staffCredits &&
                      conferenceFees.staffCredits.length > 0) ||
                      conferenceFees.eventDiscount ||
                      conferenceFees.promoCode) && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="option-text mb-2">
                            Discounts & Waivers:
                          </div>
                        </div>
                      </div>
                    )}
                    {conferenceFees.promoCode && (
                      <div className="row pb-1 discounts">
                        <div className="col-md-8">Promotional Code:</div>
                        <div className="col-md-4">
                          {conferenceFees.promoCode}
                        </div>
                      </div>
                    )}
                    {conferenceFees.staffCredits.map((item) => (
                      <div className="row discounts">
                        <div className="col-md-8">{item.reason}:</div>
                        <div className="col-md-4 red-text">
                          {item.amount.toFixed(2)}
                        </div>
                      </div>
                    ))}
                    {conferenceFees.eventDiscountTotal > 0 && (
                      <div className="row discounts">
                        <div className="col-md-8">Event Discount:</div>
                        <div className="col-md-4 red-text">
                          -${conferenceFees.eventDiscountTotal.toFixed(2)}
                        </div>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}

              {!this.state.showAllSessions && (
                <div className="pl-0 col-lg-2">
                  <div className="row mr-2">
                    <div className="pl-0">
                      <div className="option-text mb-3 text-right total-due">
                        {conferenceFees.total >= 0 ? (
                          <React.Fragment>
                            <span>Total Due: </span>
                            <span>${conferenceFees.total.toFixed(2)}</span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <span>Credit Due: </span>
                            <span>${conferenceFees.total.toFixed(2)}</span>
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {!this._hasScheduleConflicts() && (
                        <LoadingButton
                          className="mt-4"
                          onClick={(e) => this._checkout()}
                          disabled={
                            this._hasScheduleConflicts() ||
                            this.state.isCheckoutDisabled
                          }
                          text={this._actionButtonText()}
                          loadingText="Saving ..."
                          isLoading={this.state.isLoading}
                        />
                      )}

                      {this._hasScheduleConflicts() && (
                        <button
                          className="mt-4 btn btn-block btn-red"
                          onClick={(e) => this._resolveScheduleConflict()}
                        >
                          Resolve {this._getConflictingPresentationCount()}{" "}
                          Conflicts
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {this.state.showFilter && this.state.showAllSessions && (
              <div className="filter-container">
                <div className="row pt-4">
                  <div className="col-md-4">
                    <select
                      onChange={this._updateFilterType}
                      value={this.state.filterType}
                    >
                      <option value="topic">Filter By Topic</option>
                      <option value="speaker">
                        Filter By Conference Speaker
                      </option>
                    </select>
                  </div>
                  <div className="col-md-6"></div>
                  <div className="col-md-2 pl-4">
                    <button
                      className="link-button clear-filter"
                      onClick={this._clearFilters}
                    >
                      Clear Filters
                    </button>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <h4>
                      Search By{" "}
                      {this.state.filterType.charAt(0).toUpperCase() +
                        this.state.filterType.slice(1)}{" "}
                      (Up to 5):
                    </h4>
                    {this.state.filterType === "topic" && (
                      <Select
                        options={therapeuticAreaOptions}
                        isMulti={true}
                        onChange={this._updateTherapeuticAreaFilter}
                        value={this.state.selectedTherapeuticAreaOptions}
                      />
                    )}
                    {this.state.filterType === "speaker" && (
                      <Select
                        options={speakerOptions}
                        isMulti={true}
                        onChange={this._updateSpeakerFilter}
                        value={this.state.selectedSpeakerOptions}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="session-selection-header d-lg-none">
            {!this.state.showAllSessions && (
              <React.Fragment>
                <div className="row mb-4">
                  <div className="col-6 text-bold">
                    {conferenceFees.total >= 0 ? (
                      <React.Fragment>
                        <span>Total Due: </span>
                        <span>${conferenceFees.total.toFixed(2)}</span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span>Credit Due: </span>
                        <span>${conferenceFees.total.toFixed(2)}</span>
                      </React.Fragment>
                    )}
                    <button
                      className="btn-block link-button view-details"
                      onClick={(e) => this._showFeeDetailsModal()}
                    >
                      View Details
                    </button>
                  </div>
                  <div className="col-6">
                    {!this._hasScheduleConflicts() && (
                      <LoadingButton
                        className="mt-4"
                        onClick={(e) => this._checkout()}
                        disabled={
                          this._hasScheduleConflicts() ||
                          this.state.isCheckoutDisabled
                        }
                        text={this._actionButtonText()}
                        loadingText="Saving..."
                        isLoading={this.state.isLoading}
                      />
                    )}
                    {this._hasScheduleConflicts() && (
                      <button
                        className="mt-4 btn btn-block btn-red"
                        onClick={(e) => this._resolveScheduleConflict()}
                      >
                        Resolve {this._getConflictingPresentationCount()}{" "}
                        Conflicts
                      </button>
                    )}
                  </div>
                </div>
              </React.Fragment>
            )}
            <div className="row mb-2">
              <div className="col-lg-12">
                <select
                  onChange={(e) =>
                    this._setShowAllSessions(e.target.value === "All Sessions")
                  }
                  value={
                    this.state.showAllSessions
                      ? "All Sessions"
                      : "Tentative Schedule"
                  }
                >
                  <option>All Sessions</option>
                  <option>Tentative Schedule</option>
                </select>
              </div>
            </div>
            {this.state.showAllSessions && (
              <React.Fragment>
                <div className="row mb-2">
                  <div className="col-md-12">
                    <select
                      onChange={(e) =>
                        this._changeDay(parseInt(e.target.value))
                      }
                      value={this.state.currentDay}
                    >
                      {registration.daysOfTheWeek.map((day, index) => (
                        <option key={index} value={index}>
                          {day}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-lg-12">
                    <select
                      onChange={this._updateFilterType}
                      value={this.state.filterType}
                    >
                      <option value="topic">Filter By Topic</option>
                      <option value="speaker">
                        Filter By Conference Speaker
                      </option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    {this.state.filterType === "topic" && (
                      <Select
                        options={therapeuticAreaOptions}
                        isMulti={true}
                        onChange={this._updateTherapeuticAreaFilter}
                        value={this.state.selectedTherapeuticAreaOptions}
                      />
                    )}
                    {this.state.filterType === "speaker" && (
                      <Select
                        options={speakerOptions}
                        isMulti={true}
                        onChange={this._updateSpeakerFilter}
                        value={this.state.selectedSpeakerOptions}
                      />
                    )}
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
          <div className="session-container">
            {this.state.filterText && this.state.showAllSessions && (
              <div className="row mb-4">
                <div className="col-md-12">
                  <span className="d-none d-lg-inline-block">
                    <span className="filter-text-value">
                      {this.state.filterText}
                    </span>
                    <span className="filter-text">
                      Currently Filtered By :{" "}
                    </span>
                  </span>
                </div>
              </div>
            )}
            {this._waitlistApprovedPresentations()}
            {this.state.showAllSessions ? (
              <div>
                <AvailableSessions
                  presentations={filteredPresentations}
                  removeSession={this._removeSession}
                  addSession={this._addSession}
                  isLoading={this.state.isLoadingSessions}
                />
                {registration.days.length > this.state.currentDay + 1 && (
                  <div className="row d-lg-none mt-4 mb-4">
                    <div className="col-10 col-centered">
                      <button
                        className="btn btn-primary btn-block"
                        onClick={(e) =>
                          this._changeDay(this.state.currentDay + 1)
                        }
                        key={this.state.currentDay}
                      >
                        <span>Next Day - </span>
                        <Moment format="dddd">
                          {registration.days[this.state.currentDay + 1]}
                        </Moment>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <ScheduledSessions
                schedule={this.state.schedule}
                removeSession={this._removeSession}
                addSession={this._addSession}
                resolveScheduleConflict={this._resolveScheduleConflict}
                showResolveConflictModal={this._showResolveConflictModal}
                changeDay={this._changeDay}
                mobile={false}
              />
            )}
          </div>
          {this._idleModal()}
          {this._feeDetailsModal()}
          {this._removedPresentationsModal()}
        </Box>

        {this.state.showAllSessions && (
          <div className="row mt-2 mt-lg-5 justify-content-center">
            {registration.days.length > this.state.currentDay + 1 && (
              <div className="col-3 d-none d-lg-flex">
                <button
                  className="btn btn-primary btn-block"
                  onClick={(e) => this._changeDay(this.state.currentDay + 1)}
                  key={this.state.currentDay}
                >
                  <span>Next Day - </span>
                  <Moment format="dddd">
                    {registration.days[this.state.currentDay + 1]}
                  </Moment>
                </button>
              </div>
            )}
            <div className="col-10 col-lg-3">
              <button
                className="btn btn-primary btn-block"
                onClick={(e) => this._setShowAllSessions(false)}
              >
                Finalize Schedule
              </button>
            </div>
          </div>
        )}

        {!this.state.showAllSessions && !this._hasScheduleConflicts() && (
          <div
            className={
              (this.state.showAllSessions ? "d-lg-none " : "") +
              "row mt-2 mt-lg-5"
            }
          >
            <div className="col-lg-5 col-10 col-centered">
              <LoadingButton
                onClick={(e) => this._checkout()}
                disabled={
                  this._hasScheduleConflicts() || this.state.isCheckoutDisabled
                }
                text={this._actionButtonText()}
                loadingText="Saving..."
                isLoading={this.state.isLoading}
              />
            </div>
          </div>
        )}
        {!this.state.showAllSessions && this._hasScheduleConflicts() && (
          <div>
            <div className="row mt-2 mt-lg-5">
              <div className="col-lg-5 col-10 col-centered">
                <button
                  className="btn btn-block btn-red"
                  onClick={(e) => this._resolveScheduleConflict()}
                >
                  Resolve {this._getConflictingPresentationCount()} Conflicts
                </button>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-lg-8 col-10 col-centered text-center msg-conflict">
                {strings.conflictMessage}
              </div>
            </div>
          </div>
        )}
        {this._resolveConflictModal()}
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    joinRenewMembershipType: state.membership.joinRenewMembershipType,
    registrationMembershipType: state.membership.registrationMembershipType,
    me: state.account.me,
  };
};

const mapDispatchToProps = {
  ...accountActions,
  ...registrationActions,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SessionsPage)
);
